import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import { Provider } from 'react-redux';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import store from './store/create-store';
import { ENV_CONFIG } from './config/environment';
import routes from 'routes';
import AuthInitializer from 'components/AuthInitializer';
import { datadogLogs } from '@datadog/browser-logs';
import type { Site } from '@datadog/browser-core';
import mixpanel from 'mixpanel-browser';
import { markLoginPending } from 'helpers/mixpanel';

datadogLogs.init({
  ...ENV_CONFIG().DATADOG_LOGS_INIT,
  site: (ENV_CONFIG().DATADOG_LOGS_INIT as any).site as Site,
});

import 'bootstrap/dist/css/bootstrap.css';
import 'assets/scss/paper-dashboard.scss?v=1.3.1';
import 'react-phone-input-2/lib/style.css';
import 'assets/scss/main.scss?v=1.0.0';
import 'react-toastify/dist/ReactToastify.css';
import 'react-spring-bottom-sheet/dist/style.css';
import { env } from 'config/environment/env_schema/env';

if (env.REACT_APP_MIXPANEL_PROJECT_TOKEN) {
  mixpanel.init(env.REACT_APP_MIXPANEL_PROJECT_TOKEN, { persistence: 'localStorage' });
} else {
  datadogLogs.logger.warn('[mixpanel] no project token configured; tracking disabled');
}

const router = createBrowserRouter(routes);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Auth0Provider
    domain={env.REACT_APP_AUTH0_DOMAIN}
    clientId={env.REACT_APP_AUTH0_CLIENT_ID}
    useRefreshTokens={true}
    cacheLocation={'localstorage'}
    onRedirectCallback={appState => {
      markLoginPending();
      // Replaces the provider's default callback, which strips the auth params from the URL
      window.history.replaceState(
        {},
        document.title,
        appState?.returnTo ?? window.location.pathname
      );
    }}
    authorizationParams={{
      redirect_uri: `${ENV_CONFIG().SITE_URL}/dashboard`,
      audience: env.REACT_APP_AUTH0_AUDIENCE_V2,
      scope: env.REACT_APP_AUTH0_SCOPE_V2,
    }}
  >
    <Provider store={store}>
      <AuthInitializer>
        <RouterProvider router={router} />
      </AuthInitializer>
    </Provider>
  </Auth0Provider>
);
